/**
 * Project Finance Tab - Shared Utilities
 */

// Format currency
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value || 0);
};

// Format date
export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch {
    return dateStr;
  }
};

// Format date for inputs (YYYY-MM-DD)
export const formatDateInput = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr).toISOString().split('T')[0];
  } catch {
    return '';
  }
};

// Status configuration for invoices
export const INVOICE_STATUS_CONFIG = {
  draft: { label: 'Draft', color: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300' },
  pending_approval: { label: 'Pending Approval', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' },
  approved: { label: 'Approved', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
  posted: { label: 'Posted', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  partial: { label: 'Partial', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' },
  paid: { label: 'Paid', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
  voided: { label: 'Voided', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' },
  overdue: { label: 'Overdue', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' }
};

// Status configuration for payments
export const PAYMENT_STATUS_CONFIG = {
  draft: { label: 'Draft', color: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300' },
  posted: { label: 'Posted', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
  voided: { label: 'Voided', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' }
};

// Approval status configuration
export const APPROVAL_STATUS_CONFIG = {
  not_submitted: { label: 'Not Submitted', color: 'bg-slate-100 text-slate-600' },
  pending: { label: 'Pending Approval', color: 'bg-amber-100 text-amber-700' },
  approved: { label: 'Approved', color: 'bg-green-100 text-green-700' },
  rejected: { label: 'Rejected', color: 'bg-red-100 text-red-700' }
};

// Payment methods
export const PAYMENT_METHODS = [
  { value: 'check', label: 'Check' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'ach', label: 'ACH / Bank Transfer' },
  { value: 'wire', label: 'Wire Transfer' },
  { value: 'cash', label: 'Cash' },
  { value: 'other', label: 'Other' }
];

// Check user permissions
export const canUserEdit = (role) => {
  const editRoles = [
    'super_admin', 'admin', 'sales', 'sales_rep', 'sales_manager',
    'director_of_sales', 'ops', 'operations', 'ops_manager', 'finance', 'owner'
  ];
  return editRoles.includes(role);
};

// Check if user can see pay structures (Admin/Finance only)
export const canSeePayStructures = (role) => {
  const payRoles = ['super_admin', 'admin', 'finance', 'owner'];
  return payRoles.includes(role);
};
